import * as React from "react";
import { App } from "./app"

interface ToolbarButtonVm {
    buttonID: string
    imageNR: number
    tooltipText: string
    app: App
}

interface ButtonState {
    hoverState: string
}

/* ToolbarButton is a buttonlike control designed for the toobar, it is generated using two
 * image files, the "toolbarFaces.png" from where it reads the symbol image for the button, 
 * and the "toolbarBGStates" where the buttonlike background is read, which then depends on 
 * hovering / pressed state of the mouse.
 * Clicks on these buttons are passed on to a handler within BDKalkCore, where various actions
 * will take place depending on the buttonID property of the clicked button */

export class ToolbarButton extends React.Component<ToolbarButtonVm, ButtonState> {
    constructor(props: ToolbarButtonVm) {
        super(props)
    }

    state: ButtonState = {
        hoverState: "out"
    }

    // Passes on clicks to a handler within Core:
    onClick() {
        this.props.app.GetCore().HandleButton(this.props.buttonID)
    }

    // Handler for mouse out changes the state of the button, which only affects the graphics
    mouseOutHandler(e: React.MouseEvent<HTMLDivElement>) {
        this.setState({ hoverState: "out"})
    }

    // Handler for mouse over changes the state of the button, which only affects the graphics
    mouseOverHandler(e: React.MouseEvent<HTMLDivElement>) {
        this.setState({ hoverState: "hover" })
    }

    // Handler for mouse down changes the state of the button, which only affects the graphics
    mouseDownHandler(e: React.MouseEvent<HTMLDivElement>) {
        this.setState({ hoverState: "pressed" })
    }

    // Handler for mouse up changes the state of the button, which only affects the graphics
    mouseUpHandler(e: React.MouseEvent<HTMLDivElement>) {
        this.setState({ hoverState: "hover" })
    }

    render() {
        const iconFile = "url(images/ToolbarFaces.png)"
        const bgFile = "url(images/ToolbarBGStates.png)"
        const buttonWidth = 30
        const buttonHeight = 34

        // imageNR tells what part of the image should be applied (using offsets)
        var iconX = this.props.imageNR % 10
        var iconY = (this.props.imageNR - iconX) / 10
        var pressedY = 0
        
        // The current hover state also affect the image offsets
        var bgPosX = "0px"

        if (this.state.hoverState == "out") {
            bgPosX = "0px"
        }

        if (this.state.hoverState == "hover") {
            bgPosX = "-30px"
        }

        if (this.state.hoverState == "pressed") {
            bgPosX = "-60px"
            pressedY = 1
        }

        // Putting together the background image positions
        var bgPositionIcon = (-iconX * 25).toString() + "px " + (((-iconY * 30)-1) + pressedY).toString() + "px"
        var bgPositionButton = bgPosX + " 0px"

        // Rendering the resulting button
        return <div className="tooltip"
            style={{
                marginLeft: "0px", backgroundImage: bgFile, backgroundPosition: bgPositionButton, height: "34px", width: "30px" }}
                onClick={this.onClick.bind(this)}
                onMouseOut={e => this.mouseOutHandler(e)}
                onMouseOver={e => this.mouseOverHandler(e)}
                onMouseDown={e => this.mouseDownHandler(e)}
                onMouseUp={e => this.mouseUpHandler(e)}>
            <div style={{ marginLeft: "0px", height: "25px", width: "24px", position: "relative", top: "4px", left: "3px", backgroundImage: iconFile, backgroundPosition: bgPositionIcon }}>
            </div>
            <span className="tooltiptext">{this.props.tooltipText}</span>
        </div>
    }
}



// WEBPACK FOOTER //
// ./client/view/ToolbarButton.tsx